import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import "swiper/css/effect-fade";
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import './Header.css';

// import required modules
import { EffectFade, Autoplay, Pagination, Navigation } from 'swiper';


function PopupAd() {
    const [isOpen, setIsOpen] = useState(true);
  
    const handleClose = () => {
      setIsOpen(false);
    };
  
    if (!isOpen) {
      return null;
    }
  
    return (
      <div className="popup-ad">
        <div className="popup-content">
        <a href="/network-engineering-bootcamp">
          <h3 style={{color:"#F17C0A"}}>Attention !!&nbsp;&nbsp;</h3>
          </a>
          <a href="/network-engineering-bootcamp">
          <p style={{color:"#7D17DA", fontWeight:"500"}}> Upcoming Network Engineering Boot Camp.</p>
          </a>
          
          <button className="close-button" onClick={handleClose}>
            Close
          </button>
        </div>
      </div>
    );
  }
  

function Header() {
  return (
    <div id='home'>
      <Swiper
        effect={"fade"}
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[EffectFade, Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        <SwiperSlide>
            <div className='slide1'>
                <div className="overlay"></div>
                <div className="container" style={{ zIndex: '1'}}>
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <hr className='hr'/>
                            <h3><span className="bold bd1">Welcome to Seven Group Academy</span></h3>
                            <h3><span className="bold bd2">WE TEACH</span></h3>
                            <h1 className="heading text-animation">WEB DEVELOPMENT</h1>
                            <a class="btn light" href="/learn-more">Learn More</a>
                            <a class="btn dark" href="/apply-now">Enroll Now</a>
                        </div>
                    </div>
	            </div>	
            </div>
        </SwiperSlide>


        <SwiperSlide>
            <div className='slide2'>
                <div class="overlay"></div>
                <div className="container" style={{ zIndex: '1'}}>
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <hr className='hr'/>
                            <h3><span className="bold bd1">Welcome to Seven Group Academy</span></h3>
                            <h3><span className="bold bd2">WE TEACH</span></h3>
                            <h1 className="heading text-animation">COMPUTER HARDWARE</h1>
                            <a class="btn light" href="/learn-more">Learn More</a>
                            <a class="btn dark" href="/apply-now">Enroll Now</a>
                        </div>
                    </div>
	            </div>	
            </div>
        </SwiperSlide>

        <SwiperSlide>
            <div className='slide3'>
                <div class="overlay"></div>
                <div className="container" style={{ zIndex: '1'}}>
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <hr className='hr'/>
                            <h3><span className="bold bd1">Welcome to Seven Group Academy</span></h3>
                            <h3><span className="bold bd2">WE TEACH</span></h3>
                            <h1 className="heading text-animation">PYTHON PROGRAMMING</h1>
                            <a class="btn light" href="/learn-more">Learn More</a>
                            <a class="btn dark" href="/apply-now">Enroll Now</a>
                        </div>
                    </div>
	            </div>	
            </div>
        </SwiperSlide>
        
        <SwiperSlide>
            <div className='slide4'>
                <div class="overlay"></div>
                <div className="container" style={{ zIndex: '1'}}>
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <hr className='hr'/>
                            <h3><span className="bold bd1">Welcome to Seven Group Academy</span></h3>
                            <h3><span className="bold bd2">WE TEACH</span></h3>
                            <h1 className="heading text-animation">GRAPHIC DESIGN</h1>
                            <a class="btn light" href="/learn-more">Learn More</a>
                            <a class="btn dark" href="/apply-now">Enroll Now</a>
                        </div>
                    </div>
	            </div>	
            </div>
        </SwiperSlide>
        
        <SwiperSlide>
            <div className='slide5'>
                <div class="overlay"></div>
                <div className="container" style={{ zIndex: '1'}}>
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <hr className='hr'/>
                            <h3><span className="bold bd1">Welcome to Seven Group Academy</span></h3>
                            <h3><span className="bold bd2">WE TEACH</span></h3>
                            <h1 className="heading text-animation">COMPUTER NETWORKING</h1>
                            <a class="btn light" href="/learn-more">Learn More</a>
                            <a class="btn dark" href="/apply-now">Enroll Now</a>
                        </div>
                    </div>
	            </div>	
            </div>
        </SwiperSlide>
        
        <SwiperSlide>
            <div className='slide6'>
                <div class="overlay"></div>
                <div className="container" style={{ zIndex: '1'}}>
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <hr className='hr'/>
                            <h3><span className="bold bd1">Welcome to Seven Group Academy</span></h3>
                            <h3><span className="bold bd2">WE TEACH</span></h3>
                            <h1 className="heading text-animation">UI/UX DESIGN</h1>
                            <a class="btn light" href="/learn-more">Learn More</a>
                            <a class="btn dark" href="/apply-now">Enroll Now</a>
                        </div>
                    </div>
	            </div>	
            </div>
        </SwiperSlide>
        
        <SwiperSlide>
            <div className='slide7'>
                <div class="overlay"></div>
                <div className="container" style={{ zIndex: '1'}}>
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <hr className='hr'/>
                            <h3><span className="bold bd1">Welcome to Seven Group Academy</span></h3>
                            <h3><span className="bold bd2">WE TEACH</span></h3>
                            <h1 className="heading text-animation">DATA ANALYTICS</h1>
                            <a class="btn light" href="/learn-more">Learn More</a>
                            <a class="btn dark" href="/apply-now">Enroll Now</a>
                        </div>
                    </div>
	            </div>	
            </div>
        </SwiperSlide>
      </Swiper>
      <PopupAd />
    </div>
  );
}

export default Header;
